import { BuyIcon, DepositIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";
import { useNavigate } from "react-router-dom";

export const WalletActionsPanel = () => {
  const navigate = useNavigate();

  return (
    <div className="flex gap-2">
      <div
        onClick={() => navigate(RoutePath.Deposit)}
        className="group flex gap-1 justify-center items-center bg-card_bg rounded-full w-1/2 text-xs text-text_primary font-bold cursor-pointer h-[30px]"
      >
        <p className="group-hover:text-button_text_secondary">Deposit</p>
        <DepositIcon className="w-4 h-4 group-hover:!fill-button_bg_secondary" />
      </div>
      <div
        onClick={() => {
          navigate(RoutePath.Buy);
        }}
        className="group flex gap-1 justify-center items-center bg-card_bg rounded-full w-1/2 text-xs text-text_primary font-bold cursor-pointer h-[30px]"
      >
        <p className="group-hover:text-button_text_secondary">Buy</p>
        <BuyIcon className="w-4 h-4 group-hover:!fill-button_bg_secondary" />
      </div>
      {/* <div
            onClick={() => navigate(RoutePath.Withdraw)}
            className="flex justify-center items-center bg-card_bg rounded-full w-1/3 py-2 text-xs text-text_primary font-bold hover:text-button_text_secondary cursor-pointer"
          >
            Withdraw
          </div> */}
    </div>
  );
};
